import { ELoginMethods, ESessionStorageKeys } from '@/lib/enums';
import { useLoginState } from '@/state/hooks/login.state.hook';
import { webStorageUtil } from '@/state/webStorage.state.service';
import { LoginButton } from '@/components/portal-ui';
import { TokenResponse, useGoogleLogin } from '@react-oauth/google';

import { useTranslations } from 'next-intl';

export const GoogleLoginButton = () => {
  const t = useTranslations();
  const { loginResponse, shouldDisableLoginButtons, loginButtonClickWrapper, setIsLoggingIn } =
    useLoginState();

  const handleNonOAuthError = async () => {
    setIsLoggingIn(false);
    console.log('failed google login');
    // sendPublisherWebhookLoginEvent({
    //   eventName: ELoginEvents.LOGIN_CANCELED,
    //   method: ELoginMethods.GOOGLE,
    // });
    // sendPublisherWebhookLoginEventV2({
    //   eventName: ELoginEventsV2.WEBSTORE_LOGIN_CANCELED,
    //   method: ELoginMethods.GOOGLE,
    //   eventType: EPublisherWebhookEventTypeV2.PRE_LOGIN,
    // });
  };

  const googleLoginClickHandler = useGoogleLogin({
    onSuccess: (tokenResponse) => googleResponseHandler(tokenResponse),
    onNonOAuthError: handleNonOAuthError
  });

  const googleResponseHandler = (response: TokenResponse) => {
    if (!response.access_token) return;

    const data = {
      userToken: response.access_token,
      authMethod: ELoginMethods.GOOGLE
    };
    webStorageUtil.remove(ESessionStorageKeys.REDIRECT_STATE);
    loginResponse(data);
  };

  return (
    <LoginButton
      variant='google'
      callback={() => loginButtonClickWrapper(googleLoginClickHandler, ELoginMethods.GOOGLE)}
      text={t('portal.login.continueWithGoogle')}
      dataTestId='google-login-button'
      isDisabled={shouldDisableLoginButtons}
      opacityOnDisabled={false}
      isModalMode={true}>
      <img src='https://media.appcharge.com/defaults/google_icon.svg' alt='google icon' />
    </LoginButton>
  );
};
